<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
          <h1 class="h3 mb-0 text-gray-800"></h1>
        </div>

        <div class="loading text-center">
          <br />
          <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
          <br />
          <p>Loading, please wait...</p>
        </div>
      </div>
    </div>
  </div>
</div>
